import React, { useState, useMemo } from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { Container, Row, Col } from 'reactstrap'
import { useThemeState } from "../context/theme";
import PoweredBy from '../images/logo/poweredby.png'
import Logo from '../images/logo/logo.svg'

import DocumentModal from './DocumentModal'
import TermsAndConditions from './TermsAndConditions'
import PrivacyPolicy from './PrivacyPolicy'

function Footer() {
    return (
        <footer className="footer fixed-bottom bg-primary border-top">
            <Container>
                    <Row className="align-items-center">
                        <Col sm={1}>
                            <img src={Logo} width={100} alt="Trato Logo" />
                        </Col>
                        <Col sm={8} className="">
                            <ul className="d-inline list-inline mb-0 text-white d-flex align-items-center w-100 justify-content-center">
                                <li className="list-inline-item">
                                    <SocialButton url="https://www.facebook.com/tratoapp" icon={["fab", "facebook"]} />
                                </li>
                                <li className="list-inline-item">
                                    <SocialButton url="https://wa.me/5215581079280?text=Hola%2C%20quiero%20empezar%20a%20gestionar%20mis%20contratos" icon={["fab", "whatsapp"]} />
                                </li>
                                <li className="list-inline-item">
                                    <SocialButton url="https://www.linkedin.com/company/contratosapp/" icon={["fab", "linkedin"]} />
                                </li>
                                <li className="list-inline-item">
                                    <SocialButton url="https://twitter.com/TratoApp" icon={["fab", "twitter"]} />
                                </li>
                                <li className="list-inline-item">
                                    <SocialButton url="mailto:hola@trato.io" icon={["fa", "envelope"]} />
                                </li>
                            </ul>
                        </Col>
                        <Col sm={3}>
                            <DocumentModal buttonClassName="mr-2 font-size-12" tag="a" href="#" DocumentComponent={TermsAndConditions}>Términos y Condiciones</DocumentModal>
                            <DocumentModal buttonClassName="font-size-12" tag="a" href="#" DocumentComponent={PrivacyPolicy}>Aviso de Privacidad</DocumentModal>
                        </Col>
                    </Row>
            </Container>
        </footer>
    )
}

function SocialButton({ icon, url }) {
    return (
        <a href={url} target="_blank" rel="noopener noreferrer" className="rounded-circle text-white">
            <FontAwesomeIcon icon={icon} />
        </a>
    )
}

function OldFooter () {
    const theme = useThemeState();
    
    const currentYear = useMemo(() => new Date().getFullYear(), [])

    return (
        <footer className="footer fixed-bottom bg-light border-top">
            <Container>
                <Row>
                    <Col md={theme.isPartner ? 2 : 7} className="d-flex">
                        <p className="font-weight-bold mb-0">© {currentYear} Trato Starter</p>
                        {/* {theme.isPartner && <img src={PoweredBy} alt="Powered by Trato" />} */}
                    </Col>
                    {theme.isPartner && <Col md={5}>
                        <img src={PoweredBy} width={150} alt="Powered by Trato" />
                    </Col>  }
                    <Col md={5}>
                    
                    </Col>
                </Row>
            </Container>
        </footer>

    );
}

export default Footer;